var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.title},scopedSlots:_vm._u([(_vm.showLeftArrow)?{key:"left",fn:function(){return [_c('van-icon',{attrs:{"name":"arrow-left","size":"18","color":"#3f3ad2"},on:{"click":_vm.onClickLeft}})]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }